import {
    TITLE_DETAILS_FIELDS,
    GENRE_DETAILS_FIELDS,
    OTHER_DETAILS_FIELDS,
    VIDEOGAMES_DETAILS_FIELDS,
    FVG_DOWNLOAD
} from './classificationOfVideoGames';
import { TITLE_DETAILS_FIELDS as DIS_TITLE_DETAILS_FIELDS } from './declarationOfInteractiveSoftware';
import {
    CONTENT_QUESTIONS_I_FIELDS,
    CONTENT_QUESTIONS_II_FIELDS,
    CONTENT_QUESTIONS_III_FIELDS,
    CONTENT_QUESTIONS_IV_FIELDS
} from './ContentQuestion/index';
import APPLICATION_DELETE from '../applicationDelete';
import { ADDITIONAL_INFORMATION_FIELDS, APPLICATION_SUBMISSION_FIELDS } from './applicationSubmission';
import { CASE_TYPE_ID } from 'common/constants';
import SUMMARY from '../Summary';
import { GENERAL_FIELDS, COMPANY_FIELDS } from './applicantCompany';

export const VIDEO_GAMES = [
    {
        title: 'Video Game Classification',
        steps: [
            'Title Search',
            'Advisory on Gambling Control Act.',
            'Applicant and Application Details',
            'Content Questions',
            'Application Submission',
            'Review'
        ],
        caseType: CASE_TYPE_ID.VIDEO_GAMES,
        actionSave: 'pyUpdateCaseDetails',
        actionCollect: 'ApplicationDetails',
        actionReview: 'ReviewFVGScreen',
        forms: [
            {
                formID: 'appDetails-generalApplicant',
                title: 'Applicant Details',
                fields: GENERAL_FIELDS,
                submitBtn: { id: 'submit-general', title: 'Next Section' },
                prevBtn: { id: 'prev-general', title: 'Previous Section' }
            },
            {
                formID: 'appDetails-generalCompany',
                title: 'Applicant/Organisation Details',
                fields: COMPANY_FIELDS,
                submitBtn: { id: 'submit-general', title: 'Next Section' },
                prevBtn: { id: 'prev-general', title: 'Previous Section' }
            },

            {
                formID: 'application-delete',
                title: '',
                fields: APPLICATION_DELETE
            },
            {
                formID: 'summary',
                title: '',
                fields: SUMMARY
            },
            {
                formID: 'download',
                title: '',
                fields: FVG_DOWNLOAD
            },
            {
                formID: 'appDetails-title',
                title: 'Title Details',
                fieldIDTitle: 'title-details-title',
                multiple: true,
                fields: TITLE_DETAILS_FIELDS,
                prevBtn: { id: 'prev-general', title: 'Previous Section' },
                submitBtn: { id: 'submit-general', title: 'Next Section' }
            },
            {
                formID: 'appDetails-genre',
                title: 'Video Game Genre Details',
                fieldIDTitle: 'genre-details-title',
                multiple: true,
                fields: GENRE_DETAILS_FIELDS,
                prevBtn: { id: 'prev-general', title: 'Previous Section' },
                submitBtn: { id: 'submit-general', title: 'Next Section' }
            },
            {
                formID: 'appDetails-others',
                title: 'Ratings by Other Rating Boards',
                fieldIDTitle: 'others-details-title',
                multiple: true,
                fields: OTHER_DETAILS_FIELDS,
                prevBtn: { id: 'prev-general', title: 'Previous Section' },
                submitBtn: { id: 'submit-general', title: 'Next Section' }
            },
            {
                formID: 'content-1',
                title: 'Content Question - 1',
                multiple: true,
                fields: CONTENT_QUESTIONS_I_FIELDS,
                prevBtn: { id: 'prev-general', title: 'Previous Section' },
                submitBtn: { id: 'submit-general', title: 'Next Section' }
            },
            {
                formID: 'content-2',
                title: 'Content Question - 2',
                multiple: true,
                fields: CONTENT_QUESTIONS_II_FIELDS,
                prevBtn: { id: 'prev-general', title: 'Previous Section' },
                submitBtn: { id: 'submit-general', title: 'Next Section' }
            },
            {
                formID: 'content-3',
                title: 'Content Question - 3',
                multiple: true,
                fields: CONTENT_QUESTIONS_III_FIELDS,
                prevBtn: { id: 'prev-general', title: 'Previous Section' },
                submitBtn: { id: 'submit-general', title: 'Next Section' }
            },
            {
                formID: 'content-4',
                title: 'Content Question - 4',
                multiple: true,
                fields: CONTENT_QUESTIONS_IV_FIELDS,
                prevBtn: { id: 'prev-general', title: 'Previous Section' },
                submitBtn: { id: 'submit-general', title: 'Next Section' }
            },
            {
                formID: 'appSubmission',
                title: 'Application Submission',
                multiple: true,
                fields: APPLICATION_SUBMISSION_FIELDS,
                prevBtn: { id: 'prev-general', title: 'Previous Section' },
                submitBtn: { id: 'submit-general', title: 'Review' }
            },
            {
                formID: 'videogamesDetails',
                title: 'Video Games Details',
                fields: VIDEOGAMES_DETAILS_FIELDS
            },
            {
                formID: 'videogamesAdditionalInformation',
                title: '',
                fields: ADDITIONAL_INFORMATION_FIELDS
            }
        ]
    }
];

export const DECLARATION_OF_INTERACTIVE_SOFTWARE = [
    {
        title: 'Declaration of Interactive Software',
        steps: ['Applicant and Application Details', 'Review'],
        caseType: CASE_TYPE_ID.INTERACTIVE_SOFTWARE,
        actionSave: 'pyUpdateCaseDetails',
        actionCollect: 'ApplicationDetails',
        actionReview: 'ReviewFVGScreen',
        forms: [
            {
                formID: 'appDetails-generalApplicant',
                title: 'Applicant Details',
                fields: GENERAL_FIELDS,
                submitBtn: { id: 'submit-general', title: 'Next Section' }
            },
            {
                formID: 'appDetails-generalCompany',
                title: 'Applicant/Organisation Details',
                fields: COMPANY_FIELDS,
                submitBtn: { id: 'submit-general', title: 'Next Section' }
            },
            {
                formID: 'application-delete',
                title: '',
                fields: APPLICATION_DELETE
            },
            {
                formID: 'summary',
                title: '',
                fields: SUMMARY
            },
            {
                formID: 'download',
                title: '',
                fields: FVG_DOWNLOAD
            },
            {
                formID: 'appDetails-title',
                title: 'Application Details',
                fieldIDTitle: 'title-details-title',
                multiple: true,
                fields: DIS_TITLE_DETAILS_FIELDS,
                addBtn: { id: 'add-new', title: 'Add New Title' },
                submitBtn: { id: 'submit-general', title: 'Review' }
            }
        ]
    }
];
